/**
 * @license Siftrock
 * (c) 2014-2018 Siftrock, Inc. http://siftrock.com
 * Unauthorized copying of this file, via any medium is strictly prohibited
 */

import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { GlobalMessageService } from '../services/global-message.service';
import { AuthService } from '../services/auth.service';
import { DriftService } from '../services/drift.service';

import { FormValidators } from '../global/form-validators';
import { Animations } from '../global/animations';

@Component({
  selector: 'app-password-reset',
  templateUrl: './password-reset.component.html',
  styleUrls: ['./password-reset.component.scss'],
  animations: Animations.authForms
})
export class PasswordResetComponent implements OnInit {

  passwordForm: FormGroup;
  visible: string = 'off';
  token: string = '';
  emailAddress: string = '';
  validToken: boolean = true;

  constructor(private route: ActivatedRoute,
              private fb: FormBuilder,
              private authService: AuthService,
              private globalMessageService: GlobalMessageService,
              private driftService: DriftService) {
    this.passwordForm = fb.group({
      pw1: ['', Validators.compose([Validators.required, Validators.minLength(8), FormValidators.passwordMatchValidator, FormValidators.passwordRequirementValidator])],
      pw2: ['', Validators.compose([Validators.required, Validators.minLength(8), FormValidators.passwordMatchValidator])]
    });
    // so we can trigger match validator
    this.passwordForm.controls['pw2'].valueChanges.subscribe(data => {
      this.passwordForm.controls['pw1'].updateValueAndValidity();
    });
  }

  ngOnInit() {
    this.authService.logout().subscribe(
      (result: any) => {
        setTimeout(() => {
          this.visible = 'on';
        }, 10);
        this.initView();
      }
    )
  }

  submitForm() {
    var pw = this.passwordForm.controls['pw1'].value;
    this.passwordForm.controls['pw1'].setValue('');
    this.passwordForm.controls['pw2'].setValue('');
    this.authService.changePassword(this.token, this.emailAddress, pw).subscribe(
      (result: any) => {
        this.globalMessageService.message('Your password was changed, logging in...');
        setTimeout(() => {
          this.authService.login(this.emailAddress, pw).subscribe(
            (result: any) => {
              this.driftService.identify();
              this.driftService.track('changed-password');
              this.driftService.track('login');
            },
            error => {
              this.globalMessageService.error();
            }
          )
        }, 1500);
      },
      error => {
        this.globalMessageService.error();
      }
    )
  }

  private initView() {
    this.route.params.subscribe(
      params => {
        this.token = params['token'];
        this.authService.getEmailAddressByToken(params['token']).subscribe(
          (result: any) => {
            if (!result) {
              // invalid token
              this.validToken = false;
            }
            else {
              this.emailAddress = result.email_address;
            }
          },
          error => {
            // 404 means no user or token found
            if (error.status == 404) {
              this.validToken = false;
            }
            else {
              this.globalMessageService.error();
            }
          }
        )
      }
    )
  }
}



// WEBPACK FOOTER //
// ./client/app/password-reset/password-reset.component.ts